var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_51818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3801 15.7861L23.7522 23.1678M18.8752 9.75597C18.8752 14.4696 15.054 18.2907 10.3404 18.2907C5.62676 18.2907 1.8056 14.4696 1.8056 9.75597C1.8056 5.04234 5.62676 1.22119 10.3404 1.22119C15.054 1.22119 18.8752 5.04234 18.8752 9.75597Z",
    stroke: "#0099CC",
    strokeWidth: 1.9084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_51818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.855,
    height: 23.855,
    fill: "white",
    transform: "translate(0.851379 0.26709)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSelected);
export default __webpack_public_path__ + "static/media/search-selected.8e44355359364dd947b26a58632cd1a2.svg";
export { ForwardRef as ReactComponent };